<template>
  <div class="bg-gray p-2 mt-1">
    <validation-observer ref="articuleAdd">
      <div class="row mx-0 mt-3 ml-n2">
        <div class="col col-sm my-1">
          <validation-provider v-slot="{ errors }" rules="required">
            <custom-input
              v-model="articleName"
              :error="errors[0]"
              maxlength="250"
              placeholder="Escriba aquí para añadir artículo..."
              custom-error-msg="El nombre de artículo es requerido."
            />
          </validation-provider>
        </div>
        <div class="col-sm-12 col-md-12 col-lg-3 ml-0 mr-0 my-1">
          <div
            class="d-flex justify-content-md-end justify-content-sm-start no-actionbtn-width"
          >
            <action-button
              variant="outline-danger mr-2"
              i="fas fa-times-circle"
              text="Cancelar"
              class="col-sm filter-search-button"
              @click="$emit('onClose')"
            />
            <action-button
              variant="success"
              text="Añadir"
              i="fas fa-file-plus"
              class="col-sm filter-search-button"
              @click="onSaveHandler"
            />
          </div>
        </div>
      </div>
    </validation-observer>
  </div>
</template>

<script>
import CustomInput from 'CustomInput';
import ActionButton from 'ActionButton';
import alertMixin from 'utils/mixins/alert.mixin';

export default {
  name: 'ArticleAdd',
  mixins: [alertMixin],
  components: {
    CustomInput,
    ActionButton,
  },
  data: () => ({
    articleName: null,
  }),
  methods: {
    async onSaveHandler() {
      const isValid = await this.$refs.articuleAdd.validate();
      if (!isValid) {
        this.ShowToast(
          'Atención',
          'Favor escriba el nombre de artículo para poder continuar.',
          'error'
        );
        return;
      }
      this.$emit('onSaveArticle', this.articleName);
    },
  },
};
</script>

<style></style>
